export interface IScanResultOption {
  isCategoryListView: boolean;
  focusKeyForTreeModal: string;
  focusKeyForListModal: string;
  isCompleted: boolean;
  focusOnNextRow: boolean;
  customEntityIdPath?: string;
  customNamePath?: string;
}

export enum EnsureIndexVisiblePosition {
  Top = 'top',
  Bottom = 'bottom',
  Middle = 'middle',
}

export interface IScanningRenderOptions {
  firstItemIndex: number;
  isCompleted: boolean;
  autoFocusItemIndex: number;
  focusKeyForListModal: string;
}
